export default "__VITE_ASSET__nsztyTsX__"